// App.js

import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'tailwindcss/tailwind.css';
import Navbar from "./components/navbar/Navbar";
import Banner from "./components/banner/bannermain";
import About from "./components/about/About";
import Publications from "./components/publications/Publications";
import Team from "./components/team/Team";
import More from "./components/more/More";
import Contact from "./components/contact/Contact";
import OngoingProjects from "./components/ongoingProjects/OngoingProjects"; 
import ToolsPage from "./components/tools/ToolsPage";
import AllPublications from "./components/publications/AllPublications";
import Footer from "./components/footer/Footer";
import GalleryPage from "./components/Gallery/gallery";

function App() {
  return (
    <Router>
      <div className="w-full h-auto bg-bodyColor text-light">
        <Navbar />
        <main className="container mx-auto p-4">
          <Routes>
            <Route path="/" element={<Banner />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/team" element={<Team />} />
            <Route path="/more" element={<More />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/ongoing-projects" element={<OngoingProjects />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/all-publications" element={<AllPublications />} />
            <Route path="/gallery" element={<GalleryPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
